
import { Component, Vue } from 'vue-property-decorator';
import OsButton from '@/components/core/OsButton.vue';
import OsEntityToolbar from '@/components/core/OsEntityToolbar.vue';
import OsCustomerForm from '@/components/shared/customers/OsCustomerForm.vue';
import { ICustomer, ICustomerSetting } from '@/models/application';
import { customersApi } from '@/apis';
import { AppDirtyUtil } from '@/utils/AppDirtyUtil';
import userModule from '@/store/UserModule';
@Component({
  components: { OsCustomerForm, OsEntityToolbar, OsButton }
})
export default class MyCompanyIndex extends Vue {
  appDirtyUtil: AppDirtyUtil = new AppDirtyUtil();

  customer: ICustomer | null = null;
  customerSetting: ICustomerSetting | null = null;

  loading = false;
  async mounted() {
    this.customer = await customersApi.getCustomerById(
      userModule.state.customer!.id
    );
    this.customerSetting = await customersApi.getSettings(
      userModule.state.customer!.id
    );
    this.initAppDirtyUtil();
  }

  async onSave() {
    this.loading = true;
    try {
      this.customer!.id = userModule.state.customer!.id;
      this.customer = await customersApi.updateCustomer(this.customer!);
      this.initAppDirtyUtil();
      await this.$store.dispatch('user/setCustomerName', this.customer.name);
    } finally {
      this.loading = false;
    }
  }

  undoClicked() {
    const logoUrl = this.customer!.logourl; // in case logourl has been updated, then it should not be undid because its already saved on db
    this.customer = this.appDirtyUtil.getOriginalObject();
    this.initAppDirtyUtil();
    this.customer!.logourl = logoUrl;
  }

  initAppDirtyUtil() {
    this.appDirtyUtil.init(this.customer, ['logourl']);
  }
}
